
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiPaletteColorCalibratedIec as ObiPaletteColorCalibratedIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-palette-color-calibrated-iec.js';
 
 
 

 
 export const ObiPaletteColorCalibratedIec = createComponent({
   react: React,
   tagName: 'obi-palette-color-calibrated-iec',
   elementClass: ObiPaletteColorCalibratedIecElement,
   events: {
     
   }
  });
 
 